export const SyncStatus=Object.freeze({
  SYNCED:'synced',
  PENDING_CREATE:'pending_create',
  PENDING_UPDATE:'pending_update',
  PENDING_DELETE:'pending_delete',
  CONFLICT:'conflict'
});

export function createEntityMeta({id,now=new Date().toISOString(),syncStatus=SyncStatus.PENDING_CREATE,serverVersion=0}={}){
  return Object.freeze({
    id:id||globalThis.crypto?.randomUUID?.()||`${Date.now()}-${Math.random()}`,
    createdAt:now,
    updatedAt:now,
    deletedAt:null,
    syncStatus,
    serverVersion:Number(serverVersion)||0
  });
}

export function markUpdated(entity,now=new Date().toISOString()){
  if(!entity?.id)throw new TypeError('Entity id is required');
  return {...entity,updatedAt:now,syncStatus:entity.syncStatus===SyncStatus.PENDING_CREATE?SyncStatus.PENDING_CREATE:SyncStatus.PENDING_UPDATE};
}
